var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutDefaultNew',[_vm._v(" CreateNewRouteList "),_c('SubNavbar',{attrs:{"page":"Delivery"}}),_c('div',[_c('GetCreateRouteListData')],1),_c('div',[_c('SearchRouteList')],1),_c('div',[_c('CreateRouteListHeaders')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }